import React, { Fragment } from 'react';
import { messageFormat } from '@clubmed/utils';

const shouldShowAgeInMonth = ageInNumberOfMonths => ageInNumberOfMonths <= 23;
const shouldShowAgeInYearsRange = (ageMin, ageMax) =>
  !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));

export function AvailabilityAge({
  ageMax,
  ageMin,
  childcareLabel,
  monthsLabel,
  yearLabel,
  yearsLabel,
}) {
  let message = '';
  if (shouldShowAgeInMonth(ageMax)) {
    message = messageFormat(monthsLabel).format({
      min: ageMin,
      max: ageMax,
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = messageFormat(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12),
    });
  } else {
    // Shows a single year age
    message = messageFormat(yearLabel).format({ fixed: Math.floor(ageMin / 12) });
  }
  return (
    <Fragment>
      {`${childcareLabel} `}
      <span className="whitespace-no-wrap font-normal">{message}</span>
    </Fragment>
  );
}
